import { render } from "./I18nText.vue?vue&type=template&id=f65ab778&scoped=true&ts=true"
import script from "./I18nText.vue?vue&type=script&lang=ts"
export * from "./I18nText.vue?vue&type=script&lang=ts"

import "./I18nText.vue?vue&type=style&index=0&id=f65ab778&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f65ab778"]])

export default __exports__